import React, { useState } from 'react';
import classnames from 'classnames';

import RemixArrowDownLineSVG from '../svg/icons/remix-arrow-down-line.svg';
import MarkdownRenderer from './MarkdownRenderer';

const FAQCard = ({ answer, open: defaultOpen = false, question }) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggle = () => setOpen((open) => !open);

  return (
    <div className="pt-5">
      <button
        className="flex items-baseline justify-between space-x-4 text-left w-full focus:outline-none"
        onClick={toggle}
      >
        <h4 className="font-medium text-xl">{question}</h4>
        <RemixArrowDownLineSVG
          className={classnames(
            'transition-transform duration-150 text-rock-blue transform w-5',
            {
              'rotate-180': open,
            }
          )}
        />
      </button>
      <div
        className={classnames({
          'block h-auto': open,
          'h-0 hidden': !open,
        })}
      >
        <MarkdownRenderer content={answer} />
      </div>
    </div>
  );
};

export default FAQCard;
